/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Resume_Editor_SkillsInputs */

const en_resume_editor_skills = /** @type {(inputs: Resume_Editor_SkillsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skills`)
};

const de_resume_editor_skills = /** @type {(inputs: Resume_Editor_SkillsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kenntnisse`)
};

const fr_resume_editor_skills = /** @type {(inputs: Resume_Editor_SkillsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Competences`)
};

const es_resume_editor_skills = /** @type {(inputs: Resume_Editor_SkillsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Habilidades`)
};

const it_resume_editor_skills = /** @type {(inputs: Resume_Editor_SkillsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Competenze`)
};

const nl_resume_editor_skills = /** @type {(inputs: Resume_Editor_SkillsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vaardigheden`)
};

const pl_resume_editor_skills = /** @type {(inputs: Resume_Editor_SkillsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Umiejetnosci`)
};

const fi_resume_editor_skills = /** @type {(inputs: Resume_Editor_SkillsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Taidot`)
};

const da_resume_editor_skills = /** @type {(inputs: Resume_Editor_SkillsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Faerdigheder`)
};

const sv_resume_editor_skills = /** @type {(inputs: Resume_Editor_SkillsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fardigheter`)
};

/**
* | output |
* | --- |
* | "Skills" |
*
* @param {Resume_Editor_SkillsInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const resume_editor_skills = /** @type {((inputs?: Resume_Editor_SkillsInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Resume_Editor_SkillsInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_resume_editor_skills(inputs)
	if (locale === "fr") return fr_resume_editor_skills(inputs)
	if (locale === "es") return es_resume_editor_skills(inputs)
	if (locale === "it") return it_resume_editor_skills(inputs)
	if (locale === "nl") return nl_resume_editor_skills(inputs)
	if (locale === "pl") return pl_resume_editor_skills(inputs)
	if (locale === "fi") return fi_resume_editor_skills(inputs)
	if (locale === "da") return da_resume_editor_skills(inputs)
	if (locale === "sv") return sv_resume_editor_skills(inputs)
	return en_resume_editor_skills(inputs)
});